(function ($, root) {
	$.config = function () {
		//Revolvia Design Object:

		window.rdo = {
			page: {
				pagewidth: null,
				pageheight: null,
				orientation: null,
				loaded: false,
			},
			loader: {
				loadingicon: $("#loadingicon"),
				pageOver: $("#loadingicon"),
				loaded: false,
				timeout: 1000,
			},
			nav: $(".navbar-toggle"),
			mobileMenu: $("#myNavbar"),
			header: $("header"),
			menu_closed: 1,
		};
	};
})(jQuery, this);
